module.exports = __webpack_public_path__ + "files/4ec0ce1ad061dbcae2c4fb2779e93823.png";